module.exports = __webpack_public_path__ + "static/img/ubg2.796619f7.png";